<script setup lang="ts">
import { computed, onMounted, watch } from "vue";
import { RouterLink, useRoute, useRouter } from "vue-router";
import Icon from "../Icon.vue";
import {
  journey,
  journeyActive,
  loadJourney,
} from "../../composables/onboarding";
import { t } from "../../i18n";

/**
 * "Implantação" in the rail, with the stages done, for owners and admins until go-live. On the
 * landing page it also takes them to the welcome the first time they arrive.
 */
const props = defineProps<{ slug: string; landing?: boolean }>();
const route = useRoute();
const router = useRouter();
const active = computed(() => route.path.startsWith(`/setup`));
const state = computed(() =>
  journey.slug === props.slug ? journey.state : null,
);

async function refresh() {
  const s = await loadJourney(props.slug);
  if (props.landing && s && !s.welcomedAt && !s.liveAt)
    void router.replace(`/setup/welcome`);
}
onMounted(refresh);
watch(() => props.slug, refresh);
</script>
<template>
  <div v-if="journeyActive(slug) && state" class="nav-item">
    <RouterLink
      :to="`/setup`"
      class="icon-button rail-journey"
      :class="{ active }"
      :title="t('nav.onboarding')"
      :aria-label="`${t('nav.onboarding')} · ${state.stagesDone}/${state.stages.length}`"
      ><Icon name="rocket" :size="22" /><span class="rail-journey-badge"
        >{{ state.stagesDone }}/{{ state.stages.length }}</span
      ></RouterLink
    >
  </div>
</template>
